import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import { Divider, Grid } from '@material-ui/core';
import { Magnetic as Mi } from "../../styles";
export const StyledAlbumTwistyContainer = styled('div') `
	display: flex;
	align-items: center;
	width: 100%;
	cursor: pointer;
	justify-content: space-between;
	background-color: ${Mi.twistyBaseBackgroundColor};
	min-height: ${Mi.twistyBaseMinHeight};
	padding: 0 ${Mi.spacer12} 0 ${Mi.spacer24};

	&:hover {
		background: ${Mi.twistyRowBackgroundHover};
	}

	&:active {
		background-color: ${Mi.twistyRowBackgroundActive};
	}
`;
export const StyledAlbumTwistyText = styled('span') `
	font-size: ${props => props.fontSize || Mi.twistyBaseFontSize};
	color: ${Mi.twistyBaseColor};
	font-weight: ${Mi.twistyBaseFontWeight};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	flex-grow: 1;
`;
export const StyledAlbumTwistySelectionButtonContainer = styled('div') `
	display: flex;
	align-items: center;
	margin-left: ${Mi.spacer16};
	flex-shrink: 0;
	z-index: 1;
`;
export const StyledSelectionButton = styled('button') `
	color: ${Mi.colorBrand50};
	font-size: ${Mi.fontSize14};
	text-decoration: none;
	cursor: pointer;
	font-weight: ${Mi.fontWeightNormal};
	background: none;
	border: none;
	padding: 0;
	display: inline;
	text-align: left;

	&:hover:not(:disabled) {
		text-decoration: underline;
	}

	&:active:not(:disabled) {
		color: ${Mi.colorBrand60};
	}

	&:focus {
		outline: ${Mi.menuPaddingTop} ${Mi.baseBorderStyle} ${Mi.colorBrand30};
		outline-offset: ${Mi.menuPaddingTop};
	}

	&:disabled {
		color: ${Mi.colorNeutral30};
		cursor: default;
	}
`;
export const StyledSeparator = styled(Divider) `
	height: ${Mi.spacer20};
	width: ${Mi.baseBorderWidth};
	background-color: ${Mi.colorNeutral30};
	margin: 0 ${Mi.spacer08};
	display: inline-block;
`;
export const StyledTwistyWrapper = styled('div') `
	background-color: ${Mi.twistyBaseBackgroundColor};
`;
export const StyledAlbumTwistySubHeaderText = styled('span') `
	font-size: ${props => props.fontSize ? `calc(${props.fontSize} - 2px)` : Mi.twistyBaseSubHeaderFontSize};
	font-weight: ${Mi.twistyBaseSubHeaderFontWeight};
	color: ${Mi.twistyBaseColor};
	margin-left: ${Mi.spacer08};
	white-space: nowrap;
`;
export const TileListWrapper = styled(Grid, {
    shouldForwardProp: prop => isPropValid(prop) &&
        prop != 'isSelectModeOn' &&
        prop != 'panelBackgroundColor' &&
        prop != 'tilesGap'
}) `
	width: 100%;
	padding: ${Mi.spacer20} ${Mi.spacer12} ${Mi.spacer64};
	${(props) => !!props.panelBackgroundColor
    ? `background-color: ${props.panelBackgroundColor};`
    : `background-color: ${props.isSelectModeOn ? Mi.colorMocha30 : Mi.colorWhite};`}

	${(props) => props.isSelectModeOn ? `transition: background-color 1s linear` : ''};

	${(props) => props.tilesGap
    ? `
				display: flex;
  				flex-wrap: wrap;
				gap: ${props.tilesGap};
		`
    : ''}
`;
export const TilePadding = styled(Grid) `
	padding-right: ${Mi.spacer04};
`;
//# sourceMappingURL=Style.js.map